import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

import { useIntl } from 'bundles/page/lib/useIntl';

import _t from 'i18n!nls/degree-home';

type Props = {
  hasCompletedDegree: boolean;
  termNum: number;
  creditNumPerTerm: number | null;
};

const EstimatedGraduationDescription = ({ hasCompletedDegree, termNum, creditNumPerTerm }: Props) => {
  const intl = useIntl();

  if (hasCompletedDegree) {
    return (
      <Typography2 component="p" color="supportText">
        {_t("Congratulations! All your efforts paid off and you've made it.")}
      </Typography2>
    );
  }

  if (termNum === 0) {
    return (
      <Typography2 component="p" color="supportText">
        {_t('This term based on your plan.')}
      </Typography2>
    );
  }

  if (creditNumPerTerm) {
    return (
      <div>
        <Typography2 component="p" color="supportText">
          {intl.formatMessage(
            _t('If you earn: {creditNumPerTerm} {creditNumPerTerm, plural, =1 {credit} other {credits}} per term'),
            {
              creditNumPerTerm,
            }
          )}
        </Typography2>
        <Typography2 component="p" color="supportText">
          {intl.formatMessage(_t('You will graduate: {termNum} {termNum, plural, =1 {term} other {terms}} from now'), {
            termNum,
          })}
        </Typography2>
      </div>
    );
  }
  return (
    <Typography2 component="p" color="supportText">
      {intl.formatMessage(_t('{termNum} {termNum, plural, =1 {term} other {terms}} from now based on your plan.'), {
        termNum,
      })}
    </Typography2>
  );
};

export default EstimatedGraduationDescription;
